import { type CategoryFacet } from "@/stf.data/schema";

import {
  type QueryParams,
  type ToggleRefinement,
} from "./typed";

const isListOfStrings = (value: unknown): value is string[] => {
  return (
    Array.isArray(value)
    && value.every((item) => {
      return typeof item === "string";
    })
  );
};

interface ToggleRefinementMapperProps {
  categoryVariant: CategoryFacet[];
}

const toggleRefinementMapper = (props: ToggleRefinementMapperProps) => {
  const {
    categoryVariant,
  } = props;

  return {
    createURL: (refinementList: ToggleRefinement): QueryParams => {
      const queryParams: QueryParams = {};

      if (!refinementList) {
        return queryParams;
      }

      categoryVariant.forEach((c) => {
        if (c.facetType === "toggleRefinement" && c.filterable) {
          const uiKey = `variantSku.variantDisplay.${c.label}.meta.booleanText.value`;
          const queryKey = `vt.${c.slug}`;

          const refinementValue = refinementList[uiKey];
          if (refinementValue) {
            queryParams[queryKey] = refinementValue && "1";
          }
        }
      });

      const flags: string[] = [];
      Object.entries(refinementList).forEach(([key, val]) => {
        // ie. getting "xxx" from "flags.xxxx"
        const regex = /^flags.([a-zA-Z0-9-]+)$/u;
        const match = key.match(regex);
        const flag = match ? match[1] : null;
        if (flag && val) {
          flags.push(flag);
        }
      });

      if (flags) {
        queryParams.flags = flags;
      }

      return queryParams;
    },
    parseURL: (queryParams: QueryParams | undefined): ToggleRefinement => {
      const refinementList: ToggleRefinement = {};

      if (!queryParams) {
        return undefined;
      }

      categoryVariant.forEach((c) => {
        if (c.facetType === "toggleRefinement" && c.filterable) {
          const uiKey = `variantSku.variantDisplay.${c.label}.meta.booleanText.value`;
          const queryKey = `vt.${c.slug}`;

          const refinementValue = queryParams[queryKey];
          if (
            refinementValue
            && refinementValue === "1"
          ) {
            refinementList[uiKey] = true;
          }
        }
      });

      let flags = queryParams.flags || [];
      if (flags) {
        if (typeof flags === "string") {
          flags = [flags];
        }

        if (isListOfStrings(flags)) {
          flags.forEach((f) => {
            refinementList[`flags.${f}`] = true;
          });
        }
      }

      if (Object.keys(refinementList).length === 0) {
        return undefined;
      }

      return refinementList;
    },
  };
};

export {
  toggleRefinementMapper,
};
